"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class ServicesMapper {
    toDomain(result) {
        const services = lodash_1.default.get(result, "data.getUser.guests.edges[0].node.holding.services");
        return {
            services,
        };
    }
}
exports.ServicesMapper = ServicesMapper;
